import axios from "axios";
import config from "../../config";
import { IgnoreList, IgnoreListRequest, IgnoreListsModel } from "./types";

const apiUrl = config.api;

const getIgnoreLists = async (): Promise<IgnoreListsModel> => {
  const response = await axios.get<IgnoreListsModel>(`${apiUrl}/ignore-list`);

  return response.data;
};

const addIgnoreList = async (
  ignoreListReq: IgnoreListRequest,
): Promise<IgnoreListsModel> => {
  const response = await axios.put<IgnoreListsModel>(
    `${apiUrl}/ignore-list/${ignoreListReq.type}`,
    ignoreListReq,
  );

  return response.data;
};

const deleteIgnoreList = async (
  value: IgnoreList,
  providedName: string,
): Promise<void> => {
  let id = 0;
  if ("clientId" in value) {
    id = value.clientId;
  } else if ("id" in value) {
    id = value.id;
  }

  const response = await axios.delete(
    `${apiUrl}/ignore-list/${value.entityType}/${id}`,
    {
      data: {
        entityType: value.entityType,
        id,
        providedName,
      },
    },
  );

  return response.data;
};

export { getIgnoreLists, addIgnoreList, deleteIgnoreList };
